<template lang="pug">
  #app.container(:class="classes")
    router-view
</template>

<script>
import { mapState } from 'vuex'

export default {
  created () {
    if (matchMedia) {
      const mq = window.matchMedia('(min-width: 768px)')
      mq.addListener(this.mediaQueryHandler)
      this.mediaQueryHandler(mq)
    }
    // watchでも同処理してるが '/inquiry' などwatch通らないケースがある
    this.updateTitle()
  },
  watch: {
    title () {
      this.updateTitle()
    },
  },
  computed: {
    ...mapState({
      classes: state => state.route.meta.rootComponentClasses || [],
      titleSuffix: state => state.route.meta.titleSuffix,
    }),
    title () {
      if (this.titleSuffix) {
        return `${this.siteName()} - ${this.titleSuffix}`
      }
      return this.pageTitle()
    },
  },
  methods: {
    mediaQueryHandler (mq) {
      if (mq.matches) {
        this.$store.commit('common/setPcMode')
      } else {
        this.$store.commit('common/setSpMode')
      }
    },
    updateTitle () {
      document.getElementsByTagName('title')[0].innerText = this.title
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/App.vue